module.exports = __webpack_public_path__ + "static/hex.32273580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hex.jpg
// module id = 445
// module chunks = 213534597649335